import { useTranslation } from 'react-i18next';

import NutriScoreLabel from 'classes/StandingData/NutriScoreLabel/NutriScoreLabel';

interface IProps {
	nutriScoreLabel: NutriScoreLabel;
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	selectedLanguage: string;
}

const NutriScoreLabelLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-2">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:LABEL')}</label>
							<div>
								<input
									value={
										props.nutriScoreLabel.labelTranslations[
											props.selectedLanguage
										] || ''
									}
									type="text"
									onChange={props.handleValueChange}
									className="form-control"
									name="labelTranslations"
									error-key={'LabelTranslations'}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default NutriScoreLabelLanguageInput;
